export type CampaignsStatusMessages = {
  campaignNotFoundError: string;
  campaignNotFoundDescription: string;
  campaignNotFoundAlt: string;
  campaignErrorToLoad: string;
  campaignCreateError: string;
  campaignUpdateError: string;

  campaignCreateSuccess: string;
  campaignUpdateSuccess: string;
};

export const CAMPAIGNS_STATUS_MESSAGES: CampaignsStatusMessages = {
  campaignNotFoundError: "Campanha não encontrada",
  campaignNotFoundDescription: "Não conseguimos encontrar a campanha que você está procurando",
  campaignNotFoundAlt: "Campanha não encontrada",
  campaignErrorToLoad: "Erro ao carregar a campanha",
  campaignCreateError: "Erro na criação da campanha!",
  campaignUpdateError: "Erro ao salvar a campanha!",

  campaignCreateSuccess: "Campanha criada com sucesso!",
  campaignUpdateSuccess: "Campanha atualizada com sucesso!",
};
